<template>
  <div class="input">
    <div class="input-label">口座種別</div>
    <div class="input-group">
      <input-select
        :option="accountType"
        :options="accountTypes"
        @select="(o) => accountType = o" />
    </div>
  </div>
</template>

<script>
import InputSelect from '@/components/Input/Select'

export default {
  components: {
    InputSelect
  },

  computed: {
    accountTypes: function () {
      return this.$store.getters['option/accountTypes']
    },

    accountType: {
      get: function () {
        return this.$store.state.bank.accountType
      },
      set: function (value) {
        this.$store.commit(
          'bank/setAccountType',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss'
</style>
